import React from 'react';
import styles from './mobile-case-tracking-tabs.module.scss';
import { Typography } from '@sanlam-glacier/app-common/components';

type StatusFilter = 'all' | 'inProgress' | 'completed';

interface MobileCaseTrackingTabsProps {
  statusFilter: StatusFilter;
  setStatusFilter: React.Dispatch<React.SetStateAction<StatusFilter>>;
}

export const MobileCaseTrackingTabs = ({
  statusFilter,
  setStatusFilter
}: MobileCaseTrackingTabsProps) => {
  const tabs: { key: StatusFilter; label: string }[] = [
    { key: 'all', label: 'All' },
    { key: 'inProgress', label: 'In progress' },
    { key: 'completed', label: 'Completed' }
  ];

  return (
    <div className={styles.tabs}>
      {tabs.map(({ key, label }) => (
        <button
          key={key}
          className={`${styles.tabButton} ${statusFilter === key ? styles.activeTab : ''}`}
          onClick={() => setStatusFilter(key)}
        >
          <Typography
            variant={Typography.VARIANT.B3}
            weight={statusFilter === key ? Typography.WEIGHT.MEDIUM : Typography.WEIGHT.NORMAL}
            color={statusFilter === key ? Typography.COLOR.PRIMARY : Typography.COLOR.DEFAULT}
          >
            {label}
          </Typography>
        </button>
      ))}
    </div>
  );
};
